var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-2" }, [
        _c(
          "nav",
          { staticClass: "flex space-x-8 border-b border-gray-200" },
          _vm._l(_vm.tabs, function (tab, i) {
            return _c(
              "button",
              {
                key: i,
                staticClass:
                  "cursor-pointer py-1 font-normal text-base text-gray-new hover:text-gray-900 focus:outline-none focus:text-gray-900 border-b-2 border-transparent",
                class: _vm.selectedTabStyle(i),
                on: {
                  click: function ($event) {
                    return _vm.updateTabIndex(i)
                  },
                },
              },
              [_vm._v(" " + _vm._s(tab) + " ")]
            )
          }),
          0
        ),
      ]),
      _vm._t("default", null, { selectedTabIndex: _vm.selectedTabIndex }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }